module.exports = __webpack_public_path__ + "img/female.fbf380cd.svg";